import { useId } from 'react';

interface LogoProps {
    className?: string;
    variant?: 'default' | 'white';
}

export default function Logo({ className = "w-10 h-10", variant = 'default' }: LogoProps) {
    const gradientId = useId();
    const isDefault = variant === 'default';

    return (
        <svg viewBox="0 0 40 56" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
            {isDefault && (
                <defs>
                    <linearGradient id={gradientId} x1="20" y1="0" x2="20" y2="56" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#2563eb" /> {/* Blue 600 */}
                        <stop offset="1" stopColor="#2563eb" /> {/* Blue 600 */}
                    </linearGradient>
                    <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
                        <feGaussianBlur in="SourceAlpha" stdDeviation="1" />
                        <feOffset dx="0" dy="1" result="offsetblur" />
                        <feComponentTransfer>
                            <feFuncA type="linear" slope="0.3" />
                        </feComponentTransfer>
                        <feMerge>
                            <feMergeNode />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                </defs>
            )}
            <g filter={isDefault ? "url(#shadow)" : undefined}>
                <path
                    d="M20 0C8.95 0 0 8.95 0 20c0 12 20 36 20 36s20-24 20-36c0-11.05-8.95-20-20-20z"
                    fill={isDefault ? `url(#${gradientId})` : "currentColor"}
                />
                <circle cx="20" cy="20" r="17" fill="none" stroke="white" strokeWidth="1.3" strokeOpacity={isDefault ? 0.9 : 0.4} />
                <text
                    x="20"
                    y="21"
                    textAnchor="middle"
                    dominantBaseline="central"
                    fill="white"
                    fontSize="16"
                    fontWeight="900"
                    fontFamily="'Fira Sans', sans-serif"
                    letterSpacing="-0.03em"
                    style={{ pointerEvents: 'none' }}
                >
                    TN
                </text>
            </g>
        </svg>
    );
}
